import { brandConfig } from "@nitro-ape/shared/lib/brand-config";
import { Button } from "@heroui/button";
import { i18n } from "@lingui/core";
import { Trans } from "@lingui/react";
import { Link } from "@tanstack/react-router";
import { getEnv } from "@/lib/env";

const NotFoundPage = () => {
  return (
    <section className="relative flex h-screen w-screen flex-col items-center justify-center gap-1">
      <img
        alt={i18n.t({
          id: "components.notFoundPage.backgroundAlt",
          message: "Background visual",
          comment:
            "Alt text for the decorative background image on the not-found page.",
        })}
        src={brandConfig(getEnv).loginBackgroundImagePath}
        className="absolute inset-0 z-0 h-full w-full"
      />
      <div className="z-20 flex flex-col items-center gap-3">
        <h1 className="text-3xl">
          <Trans
            id="components.notFoundPage.title"
            message="Got lost?"
            comment="Heading shown on the not-found page."
          />
        </h1>
        <h3 className="text-base font-light">
          <Trans
            id="components.notFoundPage.description"
            message="There is nothing here"
            comment="Subheading shown on the not-found page."
          />
        </h3>
        <Button
          as={Link}
          to="/explore"
          className="bg-green/10 text-green data-[hover=true]:bg-green/20 mt-3 rounded-xl text-lg"
          variant="solid"
          size="lg"
        >
          <Trans
            id="components.notFoundPage.cta"
            message="Go trade"
            comment="CTA button on the not-found page that navigates back to the pump page."
          />
        </Button>
      </div>
    </section>
  );
};

export default NotFoundPage;
